import React from 'react';

interface StepCardProps {
  stepNumber: number;
  title: string;
  description: React.ReactNode;
  icon?: React.ReactNode;
}

const StepCard: React.FC<StepCardProps> = ({ stepNumber, title, description, icon }) => {
  return (
    <div className="tw-relative tw-mx-auto tw-max-w-sm tw-border-2 tw-border-solid tw-border-stKilian tw-bg-white tw-p-8 tw-shadow-lg">
      {/* Decorative corner accents */}
      <div className="tw-absolute tw-right-4 tw-top-4 tw-h-6 tw-w-6">
        <div className="tw-absolute tw-right-0 tw-top-0 tw-h-0.5 tw-w-16 tw-bg-stKilian"></div>
        <div className="tw-absolute tw-right-0 tw-top-0 tw-h-16 tw-w-0.5 tw-bg-stKilian"></div>
      </div>
      <div className="tw-absolute tw-bottom-4 tw-left-4 tw-h-6 tw-w-6">
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-h-0.5 tw-w-16 tw-bg-stKilian"></div>
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-h-16 tw-w-0.5 tw-bg-stKilian"></div>
      </div>

      {/* Step indicator */}
      <div className="tw-absolute tw--top-4 tw-left-1/2 tw--translate-x-1/2 tw-transform">
        <div className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-bg-black">
          <span className="tw-text-sm tw-font-bold tw-text-white">{stepNumber}</span>
        </div>
      </div>

      {/* Content */}
      <div className="tw-flex tw-flex-col tw-items-center tw-pt-4 tw-text-center">
        {/* Icon */}
        {icon && <div className="tw-mb-6 tw-text-stKilian">{icon}</div>}

        {/* Title */}
        <h3 className="tw-mb-4 tw-text-2xl tw-font-bold tw-uppercase tw-leading-tight tw-text-text">
          {title}
        </h3>

        {/* Description */}
        <p className="tw-text-sm tw-leading-relaxed tw-text-text">{description}</p>
      </div>
    </div>
  );
};

export default StepCard;
